import { useParams } from "react-router-dom";

export default function Link({to, title, classname, children}) {

    const params = useParams();

    return (
        <a href={params.lang ? '/' + params.lang + '/' + to : '/pl/' + to} className={classname} alt={title}>{children}</a>
    )

}